import Form from '../_form';

export default class ProjectDonateForm extends Form {

    /* eslint-disable no-useless-constructor */
    constructor (query) {
        super(query);

        const donationPressets = [...this.form.querySelectorAll('#donation-pressets input')];
        const donationField = this.form.querySelector('#custom-donation-field input');

        const donationPressetDefault = donationPressets.filter((presset) => presset.checked)[0];

        ['input', 'change'].forEach((event) => {
            donationField.addEventListener(event, (e) => {
                e.stopPropagation();

                donationPressets.forEach((presset) => presset.checked = false);
    
                const { value } = e.target;

                this.donation = 'custom';
    
                if (!value.length) donationPressetDefault.checked = true;
            });
        });

        donationPressets.forEach((presset) => {
            presset.addEventListener('change', (e) => {
                e.stopPropagation();

                donationField.value = '';
            });
        });

        this.updateResults();

        this.updateDisabled();
    }

    updateDisabled () {
        const checkbox = this.form.querySelector('input[type="checkbox"]');

        checkbox.addEventListener('change', (e) => {
            e.stopPropagation();

            if (checkbox.checked) {
                this.submit.removeAttribute('disabled');
            } else {
                this.submit.setAttribute('disabled', '');
            }
        });
    }

    updateResults () {
        const amountEl = this.form.querySelector('#donation-amount');
        const commissionPercentEl = this.form.querySelector('#commission-percentage');
        const commissionAmountEl = this.form.querySelector('#commission-amount');
        const totalAmountEl = this.form.querySelector('#total-amount');

        const inputs = this.form.querySelectorAll('input');

        ['input', 'change'].forEach((event) => {
            inputs.forEach((input) => {
                input.addEventListener(event, (e) => {
                    e.stopPropagation();

                    const formData = new FormData(this.form);

                    const donationPresset = formData.get('donation-presset');
                    const donationCustom = formData.get('donation-custom');

                    const commissionPresset = formData.get('commission-presset');        

                    const donation = donationPresset || donationCustom;

                    amountEl.textContent = donation;
                    commissionPercentEl.textContent = commissionPresset;
                    commissionAmountEl.textContent = (donation * (commissionPresset / 100)).toFixed(2);
                    totalAmountEl.textContent = ((+amountEl.textContent) + (+commissionAmountEl.textContent)).toFixed(2);
                });
            });
        });
    }

    async finalizeForm () {
        if (this.submit) this.submit.classList.add('preload');

        const formData = new FormData(this.form);

        const projectID = formData.get('project-id');
        const projectURL = formData.get('project-url');
        const projectName = formData.get('project-name');

        const donationPresset = formData.get('donation-presset');
        const donationCustom = formData.get('donation-custom');

        const commissionPresset = formData.get('commission-presset');        

        const donation = donationPresset || donationCustom;

        try {
            await fetch('/wp-json/projects/v1/donate', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ projectID, projectURL, projectName, donation, commissionPresset })
            })
            .then((response) => response.json())
            .then((data) => {
                if (data && !data.error) {
                    this.form.classList.remove('error');
                    this.form.classList.add('sent');

                    this.NotificationManager.sendNotification('success', 'Starting Stripe session!', data.message);

                    if (data.url) {
                        setTimeout(() => window.location.href = data.url, 3000);
                    }

                    if (this.submit) this.submit.classList.remove('preload');
                } else {
                    this.NotificationManager.sendNotification('error', 'An error occurred...', data.message);

                    if (this.submit) this.submit.classList.remove('preload');

                    this.form.classList.add('error');
                }
            })
            .catch(() => {
                this.NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again');

                if (this.submit) this.submit.classList.remove('preload');

                this.form.classList.add('error');
            });
        } catch (error) {
            this.NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again');

            if (this.submit) this.submit.classList.remove('preload');

            this.form.classList.add('error');
        }
    }
}
